import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BaseDialog } from '../../base-dialog';

@Component({
  selector: 'mandae-cannot-block-package-dialog',
  templateUrl: './cannot-block-package-dialog.component.html',
  styleUrls: ['./cannot-block-package-dialog.component.scss', '../dialog-shared.scss']
})
export class CannotBlockPackageDialogComponent extends BaseDialog<CannotBlockPackageDialogComponent> {
  constructor(dialogRef: MatDialogRef<CannotBlockPackageDialogComponent>) {
    super(dialogRef);
  }
}
